import {
  AccountingState,
  IAccounting,
  PaymentMethods,
} from "@/types/db/accounting";

import { IProductSlotBooking } from "@/types/db/product-slot-booking";
import { PaymentStatus } from "@/types/db/product-slot-state";
import { nowDB } from "./dates";
import PaymentService from "@/services/payment-service";

/**
 * Sets payment status as completed for a given booking. this will update the pss and accounting
 * of the booking.
 *
 * @param booking booking to complete payment for
 */
export function completeBookingPayment(
  booking: IProductSlotBooking,
  accountingUUID: string
) {
  console.log("------------ hi from completeBookingPayment");
  // Update product slot states
  const now = nowDB();
  const pssList = booking.pssList;
  for (const pss of pssList) {
    pss.paymentStatus = PaymentStatus.Completed;
    pss.updatedAt = now;
  }

  // Updating accounting
  const accountings = booking.accountings;
  console.log("accountings");
  console.log(accountings);
  const accounting = accountings.find((acc) => acc.uuid === accountingUUID);
  if (!accounting) {
    throw new Error(`Accounting "${accountingUUID}" not found in booking`);
  }
  accounting.state = AccountingState.Completed;
  accounting.pspReference = PaymentService.pspReference;
  accounting.fullTransactionId = PaymentService.fullTransactionId;
  accounting.posPaymentMethod = PaymentService.posPaymentMethod;
  accounting.message += `\n${now} :: accounting was completed.`;
  accounting.updatedAt = now;
  accounting.completionDate = now;
  accounting.paymentDetails = PaymentService.paymentDetails;
}

/**
 * Sets accountings to Completed
 */
export function completeAccountingsBooking(accountings: IAccounting[]) {
  console.log("------ hi from completeAccountingsBooking");

  const now = nowDB();
  for (const acc of accountings) {
    // console.log("JSON.stringify(acc)");
    // console.log(JSON.stringify(acc));
    console.log("acc");
    console.log(acc);
    // We don't complete any failed/cancelled accounting
    if (
      acc.state === AccountingState.Failed ||
      acc.state == AccountingState.Cancelled
    ) {
      continue;
    }
    // Complete adyen accountings by adding all the payment details
    // Ensure that we are completing only adyen accountings that started the payment
    // And that the accounting is the same that we have in the payment service
    if (
      // (acc.state === AccountingState.Started) &&
      acc.uuid === PaymentService.serviceId &&
      acc.paymentMethod === PaymentMethods.METHOD_POS_ADYEN
    ) {
      if (PaymentService.manuallyCompleted) {
        // This Adyen accounting was completed manually
        // set payment method as "PENDING"
        acc.paymentMethod = PaymentMethods.METHOD_PENDING;

        acc.pspReference = null;
        acc.fullTransactionId = null;
        acc.posPaymentMethod = null;
        acc.message += `\n${now} :: accounting was manually completed.`;
        acc.paymentDetails = null;
      } else {
        acc.pspReference = PaymentService.pspReference;
        acc.fullTransactionId = PaymentService.fullTransactionId;
        acc.posPaymentMethod = PaymentService.posPaymentMethod;
        acc.message += `\n${now} :: accounting was completed.`;
        acc.paymentDetails = PaymentService.paymentDetails;
      }
    }

    // Complete the accounting except for the Swiss QR Code Bank Transfer
    console.log("----------- 2 completing accounting state");

    if (
      acc.paymentMethod !== PaymentMethods.METHOD_Swiss_QR_Code_Bank_Transfer
    ) {
      acc.state = AccountingState.Completed;
    }
    acc.updatedAt = now;
    acc.completionDate = now;
  }
}
